import { Injectable } from '@angular/core';
import { ErrorMessageResponse } from '@app/core/models/data-response';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({
    providedIn: 'root',
})
export class CapTaskService {
    constructor(private datatask: DataTaskService) {}

    /**
     * @datatask 2067
     * @datataskName sp_ws_p2_w_captaskresource_get
     * @params keyno of the resource to get.
     * @return promise containing the cap task resource get.
     */
    public async getCapTaskResource(params: GetCapTaskResourceParams): Promise<CapTaskResourceGet> {
        return (await this.datatask.Post(2067, params))[0];
    }

    /**
     * @datatask 2068
     * @datataskName sp_ws_p2_w_captaskresource_new_status
     * @params keyno of the resource to get.
     * @return promise containing the cap task resource get.
     */
    public async setStatus(params: SetNewCapTaskResourceStatusParams): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(2068, params))[0];
    }

    /**
     * @datatask 1458
     * @datataskName sp_ws_p2_w_captasksview_get
     * @params the type and id of what to get captasks for.
     * @return promise containing the cap tasks view get.
     */
    public async getCapTasksView(params: GetCapTasksViewParams): Promise<CapTasksViewGet> {
        return (await this.datatask.Post(1458, params))[0];
    }
}

export interface SetNewCapTaskResourceStatusParams {
    captaskresource_keyno: string | number;
    new_postatus_no: string;
}

export interface GetCapTasksViewParams {
    argtype: string;
    argvalue: string;
}

export interface CapTasksViewGet {
    argtype: string;
    argvalue: string;
    page_heading: string;
    date_fom: string;
    date_tom: string;
    selectedview: string;
}

export interface GetCapTaskResourceParams {
    captaskresource_keyno: string | number;
}

export interface CapTaskResourceGet {
    captaskresource_keyno: string;
    equipment_id: string;
    equipment_name: string;
    quantity: string;
    quantity_finished: string;
    captask_prod_id: string;
    captask_prod_name: string;
    capjob_prod_id: string;
    capjob_prod_name: string;
    po_keyno: string;
    postatus_no: string;
    postatus_name: string;
    operation_name: string;
    captaskresource_planned_start_dt: string;
    captaskresource_planned_end_dt: string;
    captaskresource_quantity_rest: string;
    capjob_prod_keyno: string;
    captask_prod_keyno: string;
    capjob_prod_nbr_of_documents: string;
    captask_prod_nbr_of_documents: string;
    order_internal_no: string;
    order_order_no: string;
    stocklocation_keyno: string;
    stocklocation_name: string;
    floating_location: '1' | '0';
    page_heading: string;
}
